__turbopack_context__.v({
  "bottom": "BadgeOverlay-module__89v8MW__bottom",
  "container": "BadgeOverlay-module__89v8MW__container",
  "image": "BadgeOverlay-module__89v8MW__image",
  "rightAligned": "BadgeOverlay-module__89v8MW__rightAligned",
});
